import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-17fd5b8a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "collab" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"collab_wrap\" data-v-17fd5b8a><div class=\"collab_wrap_txt contain_wrap\" data-v-17fd5b8a><h1 data-animation=\"paragraph\" data-v-17fd5b8a>Crocs SuperStar Collab</h1><p data-animation=\"paragraph\" data-v-17fd5b8a> We make the most confortable shoes in the world, and by partnering with some of your favourite celebrities, We bring thier designs and style to you in incredable confort. </p></div><div class=\"collab_wrap_slider\" data-v-17fd5b8a><div class=\"collab_wrap_slider_star\" data-v-17fd5b8a><div class=\"img\" data-v-17fd5b8a><img src=\"https://res.cloudinary.com/dszdgdeoh/image/upload/v1663677823/Star17_mmmjc5.svg\" alt=\"\" data-v-17fd5b8a></div></div><div class=\"collab_wrap_slider_star\" data-v-17fd5b8a><div class=\"img\" data-v-17fd5b8a><img src=\"https://res.cloudinary.com/dszdgdeoh/image/upload/v1663677822/Star13_lodkbu.svg\" alt=\"\" data-v-17fd5b8a></div></div><div class=\"collab_wrap_slider_star\" data-v-17fd5b8a><div class=\"img\" data-v-17fd5b8a><img src=\"https://res.cloudinary.com/dszdgdeoh/image/upload/v1663677822/Star16_rwo3e5.svg\" alt=\"\" data-v-17fd5b8a></div></div><div class=\"collab_wrap_slider_star\" data-v-17fd5b8a><div class=\"img\" data-v-17fd5b8a><img src=\"https://res.cloudinary.com/dszdgdeoh/image/upload/v1663677822/Star18_f3cvp6.svg\" alt=\"\" data-v-17fd5b8a></div></div></div></div>", 1)
const _hoisted_3 = [
  _hoisted_2
]

import croc from "@/db/croce.json";
import { onMounted } from "@vue/runtime-core";


export default /*#__PURE__*/_defineComponent({
  __name: 'collab',
  setup(__props) {

onMounted(() => {
     const elem = document.querySelector(".collab_wrap_slider_star:last-child")!;
     const elements = document.querySelectorAll(".collab_wrap_slider_star");

     const lastobserver = new window.IntersectionObserver((entries) => {
          const lastcard = entries[0];
          if (!lastcard.isIntersecting) {
               return;
          }
          if (lastcard.isIntersecting) {
               loadnewcard();
               lastobserver.unobserve(lastcard.target);
               lastobserver.observe(elem);
               elements[0].remove();
          }
     });
     3;
     lastobserver.observe(elem);

     const cardContainer = document.querySelector(".collab_wrap_slider");
     const loadnewcard = () => {
          for (let i = 0; i < croc.collab.length; i++) {
               const card = document.createElement("div");
               card.innerHTML = `<div class="img">
               <img src="${croc.collab[i].img}" alt>
          </div>`;
               card.classList.add("collab_wrap_slider_star");
               cardContainer?.append(card);
          }
     };
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, _hoisted_3))
}
}

})